export const enlargementLayerDefinition = {
    geometryType: 'esriGeometryPolygon',
    objectIdField: 'uniqueId',
    extent: {
        xmin: -180,
        ymin: -90,
        xmax: 180,
        ymax: 78.798667121,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'name',
            type: 'esriFieldTypeString',
            alias: 'name',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'clippingid',
            type: 'esriFieldTypeInteger',
            alias: 'clippingid',
            editable: true,
            nullable: true
        },
        {
            name: 'scale',
            type: 'esriFieldTypeInteger',
            alias: 'scale',
            editable: true,
            nullable: true
        },
        {
            name: 'fullpage',
            type: 'esriFieldTypeString',
            alias: 'fullpage',
            editable: true,
            nullable: true,
            length: 10
        },
        {
            name: 'pageorder',
            type: 'esriFieldTypeInteger',
            alias: 'pageorder',
            editable: true,
            nullable: true
        },
        {
            name: 'itemorder',
            type: 'esriFieldTypeInteger',
            alias: 'itemorder',
            editable: true,
            nullable: true
        }
    ]
};
